import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {IDeliveryFormat} from '../../models/seller/new-product.model';
import {
    ControlContainer,
    ControlValueAccessor,
    DefaultValueAccessor,
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    FormGroupDirective,
    NG_VALUE_ACCESSOR, ValidatorFn, Validators,

} from '@angular/forms';
import {delivertCourseFilterRules, deliveryCourseFiltersAvailable} from "../../models/courses/courses.model";

export const CHECKBOXES_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DeliveryCourseFiltersComponent),
    multi: true,
};

@Component({
    selector: 'itpx-delivery-course-filters',
    templateUrl: './delivery-course-filters.component.html',
    styleUrls: ['./delivery-course-filters.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
    providers: [CHECKBOXES_VALUE_ACCESSOR]


})
export class DeliveryCourseFiltersComponent implements OnInit, OnChanges, ControlValueAccessor {
    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;
    @Input() courseDeliveryFilters: IDeliveryFormat[] | null;
    @Input() checkedFilters: IDeliveryFormat[];
    @Input() typeCourse: string;
    @Input() disabled:boolean = true;
    @Output() setValue = new EventEmitter<{ id: string, configValue: string }[]>();

    form: FormGroup;

    constructor(private fb: FormBuilder) {
        this.initForm();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('courseDeliveryFilters' in changes) {
            if (this.courseDeliveryFilters && this.typeCourse) this.setupDeliveryFilters();
        }
    }

    private initForm() {
        this.form = this.fb.group({
            delivery: new FormArray([], this.AtLeastOneFieldValidator())
        });
    }

    private setupDeliveryFilters() {

        this.courseDeliveryFilters.forEach((e, i) => {
            let state = false;
            if (this.checkedFilters) {
                const findFilter = this.checkedFilters.find(el => el.id == e.id);
                state = !!findFilter;
            }
            const control = new FormControl(state);

            if (!deliveryCourseFiltersAvailable[this.typeCourse].includes(e.configKey)) {
                control.disable();
            }
            (this.form.controls.delivery as FormArray).push(control);
        });

        if (this.checkedFilters) {
            this.checkedFilters.forEach((e, i) => {
                this.setDelivery({target: {value: e.configKey, checked: true}});
            })
        }

    }

    setDelivery(ev) {
        const {value, checked} = ev.target;
        const deliveries = this.form.controls.delivery as FormArray;

        const filterRules = delivertCourseFilterRules[this.typeCourse];
        console.log(filterRules);

        if (filterRules.hasRules) {
            this.validate();
            const {controls} = deliveries;
            const rules = filterRules[value];

            controls.forEach((e, index) => {
                    if (checked) {
                        const disableByRule = !rules.includes(this.courseDeliveryFilters[index].configKey) && this.courseDeliveryFilters[index].configKey !== value;
                        if (disableByRule) {
                            e.setValue(false);
                            e.disable();
                        }
                    } else {
                        const enableByRule = !rules.includes(this.courseDeliveryFilters[index].configKey) && this.courseDeliveryFilters[index].configKey !== value;
                        if (enableByRule) e.enable();
                    }
                }
            )
        }

        this.emitValue();
    }

    private emitValue() {
        const deliveries = this.form.controls.delivery as FormArray;
        if (this.form.valid) {
            const filters = [];
            deliveries.controls.forEach((e, i) => {
                if (e.value) {
                    filters.push({
                        id: this.courseDeliveryFilters[i].id,
                        configValue: this.courseDeliveryFilters[i].configValue
                    });
                }
            });
            this.setValue.emit(filters);
        } else {
            this.setValue.emit(null);
        }

    }

    private validate() {
    }

    AtLeastOneFieldValidator(): ValidatorFn {
        return (formArray: FormArray): { [key: string]: any } | null => {
            let valid: boolean = false;
            formArray.controls.forEach((x: FormControl) => {
                if (x.value) {
                    valid = x.value
                }
            });
            return valid ? null : {error: 'at least one true'}
        }
    }

    writeValue(obj: any) {
    }

    registerOnChange(fn: any) {
    }

    registerOnTouched(fn: any) {
    }

    setDisabledState?(isDisabled: boolean) {
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/delivery-course-filters/delivery-course-filters.component.ts